import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {selectGameResults} from "../../redux/reducers/sharedStateReducer/selectors";
import './Header.css';
import {showGameEndModal} from "../../redux/actions";
import {GamePanel, GAME_PANEL_MATERIALS, GAME_PANEL_SHAPES} from "../gameUi/GamePanel";
import HeaderMineZone from "./HeaderMineZone/HeaderMineZone";
import HeaderPhaseZone from "./HeaderPhaseZone/HeaderPhaseZone";
import HeaderPlayersRow from "./HeaderPlayersRow/HeaderPlayersRow";
import HeaderActingPlayerBadge from "./HeaderActingPlayerBadge/HeaderActingPlayerBadge";
import {useDesktopLayout} from "../../hooks/visuals/useWideScreenLayout";
import {GAME_BUTTON_SIZES, GAME_BUTTON_VARIANTS, GameButton} from "../gameUi/GameButton";
import {EngravedIcon} from "../gameUi/EngravedIcon";

/**
 * Шапка матча — одна полоса цвета фазы из трех зон: слева «мое» (ресурсы,
 * политика, рынок), по центру раунд, фаза и этапы войны, справа строка
 * игроков и кнопка меню в углу. Уже 1024 px строка игроков — полоса под
 * шапкой
 */
const Header = ({handleOpenInGameMenu, isSpectatorMode = false}) => {
  const dispatch = useDispatch();
  const gameResults = useSelector(selectGameResults);
  const isDesktopLayout = useDesktopLayout();

  const onMenuClick = () => {
    if (gameResults) {
      dispatch(showGameEndModal());
    } else {
      handleOpenInGameMenu()
    }
  }

  // Шапка целиком — эмаль цвета фазы: цвет берется из data-gui-phase на
  // корне матча (см. GameContent и styles/gameUi/tokens.css), а не инлайном
  return (
    <header className={'app-header'} data-field-inset={'top'}>
      <GamePanel
        material={GAME_PANEL_MATERIALS.PHASE}
        shape={GAME_PANEL_SHAPES.BOTTOM}
        className={'app-header_plate'}
      >
        <div className={'header-content-container'}>
          <HeaderMineZone isSpectatorMode={isSpectatorMode}/>
          <HeaderPhaseZone/>
          <div className={'app-header_right-zone'}>
            {isDesktopLayout && <HeaderPlayersRow/>}
            <GameButton
              variant={GAME_BUTTON_VARIANTS.PHASE}
              size={GAME_BUTTON_SIZES.ICON}
              className={'app-header_menu-button'}
              onClick={onMenuClick}
              aria-label={'Меню'}
            >
              <EngravedIcon src={'/img/icons/menu.png'} size={24}/>
            </GameButton>
          </div>
        </div>
      </GamePanel>

      {!isDesktopLayout && (
        <GamePanel
          material={GAME_PANEL_MATERIALS.PHASE}
          shape={GAME_PANEL_SHAPES.BOTTOM}
          className={'header-players-strip'}
          data-field-inset={'top'}
        >
          <HeaderPlayersRow/>
        </GamePanel>
      )}

      {/* Плашка ходящего соперника — под его кружком, вне плит: их clip-path
          срезал бы ее */}
      <HeaderActingPlayerBadge isSpectatorMode={isSpectatorMode}/>
    </header>
  );
};

export default Header;
